const historialLaboral = {
    tableId: 'Tabla 1',
    table: [
        ['Empresa','Semanas','Fecha de alta','Fecha de baja'],
        ['Coppel, S.A. de C.V.','393','17/06/2012','26/12/2019'],
        ['Tiendas Soriana, S.A. de C.V.','456','27/08/2003','21/05/2012'],
        ['General Electric México S.A. de C.V.','368','24/03/1990','15/04/1997'],
        ['VINIK S.A. de C.V.','25','27/09/1989','23/03/1990'],
        ['','1,242','',''],
    ]
}

const pensionActual = {
    tableId: 'Tabla 2',
    titlesAlignment: 'center',
    table: [
        ['Edad','Semanas Cotizadas', 'Salario/día promedio', 'Pensión mensual'],
        ['60', '940', '$141', '$3,746'],
        ['61', '945', '$144', '$3,884'],
        ['62', '997', '$146', '$4,164'],
        ['63', '1,049', '$146', '$4,449'],
        ['64', '1,101', '$146', '$4,738'],
        ['65', '1,154', '$146', '$5,032'],
    ]
}  

const pensionMejoradaBase = {
    tableId: 'Tabla 3',
    titlesAlignment: 'center',
    table: [
        ['Edad','Semanas Cotizadas', 'Salario/día promedio', 'Pensión mensual'],
        ['60', '940', '$936', '$12,334'],
        ['61', '945', '$979', '$14,454'],
        ['62', '997', '$979', '$16,139'],
        ['63', '1,049', '$979', '$17,821'],
        ['64', '1,101', '$979', '$19,739'],
        ['65', '1,154', '$979', '$21,652'],
    ]
}

const escenario2 = {
    tableId: 'Tabla 4',
    titlesAlignment: 'center',
    table: [
        ['Edad','Semanas Cotizadas', 'Salario/día promedio', 'Pensión mensual'],
        ['60', '940', '$1,401', '$18,409'],
        ['61', '945', '$1,469', '$21,711'],
        ['62', '997', '$1,469', '$24,219'],
        ['63', '1,049', '$1,469', '$26,839'],
        ['64', '1,101', '$1,469', '$29,585'],
        ['65', '1,154', '$1,469', '$32,493'],
    ]
}

const pensionMejoradaMaxima = {
    tableId: 'Tabla 5',
    titlesAlignment: 'center',
    table: [
        ['Edad','Semanas Cotizadas', 'Salario/día promedio', 'Pensión mensual'],
        ['60', '940', '$2,067', '$27,235'],
        ['61', '945', '$2,172', '$32,129'],
        ['62', '997', '$2,172', '$35,759'],
        ['63', '1,049', '$2,172', '$39,676'],
        ['64', '1,101', '$2,172', '$43,729'],
        ['65', '1,154', '$2,172', '$48,098'],
    ]
}

const inversion = {
    tableId: 'Tabla 6',
    table: [
        ['Opciones','Inversión acumulada', 'Pensión acumulada (75 años)'],
        ['Pensión actual (Ley 73)','$0','$603,850'],
        ['Escenario 1','$180,000','$2,599,518'],
        ['Escenario 2','$270,000','$3,899,278'],
        ['Escenario 3','$399,144','$5,764,346'],
    ]
}
  
export {
    historialLaboral,
    pensionActual,
    pensionMejoradaBase,
    pensionMejoradaMaxima,
    inversion,
    escenario2
};